"use client";
import { jsxs as o, jsx as e } from "react/jsx-runtime";
const t = ({
  title: r,
  titleId: c,
  desc: i,
  descId: l,
  ...n
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": c,
    "aria-describedby": l,
    ...n,
    children: [
      i ? /* @__PURE__ */ e("desc", { id: l, children: i }) : null,
      r ? /* @__PURE__ */ e("title", { id: c, children: r }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M8.6873 9.4166c.5985 1.2466 1.4145 2.415 2.4478 3.4483s2.2017 1.8493 3.4483 2.4478c.1072.0515.1608.0772.2287.097.2411.0703.5371.0198.7413-.1264.0574-.0411.1066-.0903.2049-.1886.3007-.3007.451-.451.6021-.5493a1.72 1.72 0 0 1 1.8751 0c.1511.0983.3015.2486.6021.5493l.1676.1676c.457.457.6855.6855.8096.9309a1.72 1.72 0 0 1 0 1.5526c-.1241.2454-.3526.4739-.8096.9309l-.1356.1356c-.4554.4555-.6832.6832-.9928.8571-.3435.193-.8771.3318-1.2712.3306-.3551-.0011-.5978-.07-1.0832-.2077-2.6086-.7404-5.0701-2.1374-7.1237-4.191s-3.4506-4.5151-4.191-7.1237C4.07 7.9922 4.0011 7.7495 4 7.3944c-.0012-.394.1376-.9277.3306-1.2712.174-.3096.4017-.5374.8571-.9928l.1356-.1356c.457-.457.6855-.6855.931-.8096a1.72 1.72 0 0 1 1.5525 0c.2454.124.4739.3526.931.8096l.1675.1676c.3006.3006.451.451.5493.6021a1.72 1.72 0 0 1 0 1.875c-.0983.1512-.2486.3015-.5493.6022-.0983.0983-.1475.1475-.1886.205-.1462.204-.1967.5001-.1264.7412.0198.0679.0455.1215.097.2287"
        }
      )
    ]
  }
);
export {
  t as default
};
